<template>
  <div>
    <div class="header">
      <div v-if="userInfo" class="face">{{userInfo.realName.substr(0,1)}}</div>
    </div>
    <div class="center">
      <ul>
        <li>
          UID
          <span class="item-val">{{userInfo.guid}}</span>
        </li>
        <li>
          姓名
            <div class="item-val" >
              <span><Organization :name="userInfo.realName" type="userName" :openid="userInfo.memberKeyRaw" :useOpenData="userInfo.useOpenData" ></Organization></span>
            </div>
        </li>
        <li>
          当前公司
          <a class="item-val change-company" :href="changeCompanyUrl">
            <span class="companyId">（{{userInfo.corpId}}）</span>
            <span class="companyName">{{userInfo.enterpriseName}}</span>
            <div class="clear"></div>
          </a>
        </li>
        <li>
          当前账号
          <span class="item-val">{{userInfo.memberKeyRaw}}</span>
        </li>
        <li>
          生日
          <span
            v-if="userInfo"
            class="item-val"
          >{{userInfo.birthdayMd.substr(0,2)}}-{{userInfo.birthdayMd.substr(2,2)}}</span>
        </li>
        <li v-if="userInfo && (userInfo.openid || userInfo.openid3rd)">
          微信绑定
          <span :class="'item-val'+highlight" @click="showDialog1">{{bindDesc}}</span>
        </li>
      </ul>
    </div>
    <Logout />
    <div class="self-dialog-pop" data-v-12abd9fb v-if="dialogState1">
      <div class="self-dialog-content" style="top: 50%;">
        <div class="content-wrap">
          <p>确定要解除绑定吗？</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" @click="calDialog1">取消</a>
          <a href="javascript:;" @click="confirmDialog1($event)">确定</a>
        </div>
      </div>
    </div>
    <div class="self-dialog-pop" data-v-12abd9fb v-if="dialogState2">
      <div class="self-dialog-content" style="top: 50%;">
        <div class="content-wrap">
          <p>微信绑定已解除，如需重新绑定，请在微信环境退出登录后，点击服务号导航栏入口重新绑定。需要退出登录吗？</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" @click="calDialog2">取消</a>
          <a :href="config.cas_domin+'/bridge/do_logout.html?redirect='+encodeURIComponent(config.cas_domin+'/#/login?redirect='+encodeURIComponent(config.apps_domain+'/m/#/'))" @click="confirmDialog2">退出登录</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import config from "../../../../config/config.js";
import axios from "axios";
import Organization from "@/components/common/organization.vue";

let project = process.env.VUE_APP_PROJECT
let Logout = require(`../../../../components/${project}/Logout.vue`).default

export default {
  data() {
    return {
        openid: null,
        showD1: true,
        config: null,
        dialogState1: false,
        dialogState2: false,
        highlight: " bind",
        bindDesc: "微信已绑定"
      
    };
  },
  components: {
    Logout,
    Organization
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    }),
    changeCompanyUrl() {
      return (
        config.client_domain +
        "/m/member-change_member_company-1.html?redirect=" +
        encodeURIComponent(document.location.href)
      );
    }
  },
  created: function() {
    let _this = this;
    this.$store.dispatch("loadUserInfo");
    this.config = config;
  },
  methods: {
    calDialog1() {
      this.dialogState1 = false;
    },
    showDialog1() {
      this.dialogState1 = this.showD1 && (this.userInfo.openid  || this.userInfo.openid3rd)
    },
    confirmDialog1(event) {
      event.stopPropagation();

      let _this = this;
      axios
        .post(
          this.config.apps_domain +
            "/backend/api/fe/v3/j/private/user/wechat/unbind"
        )
        .then(res => {
          if (res.data && res.data.errno === 0) {
            this.showD1 = false
            this.calDialog1();
            this.bindDesc = "未绑定";
            this.highlight = "";
            setTimeout(function() {
              _this.showDialog2();
            }, 300);
          } else {
            this.$Message.error(res.data.error);
          }
        });
    },
    calDialog2() {
      this.dialogState2 = false;
    },
    showDialog2() {
      this.dialogState2 = true;
    },
    confirmDialog2() {
      this.calDialog2();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/_mixin.scss";

.header {
    padding-top: px2rem(46.875px);
  width: px2rem(750px);
  height: px2rem(337.5px);
  .face {
    background-color: white;
    width: px2rem(230px);
    height: px2rem(230px);
    border-radius: 100%;
    margin: 0 auto;
    text-align: center;
    line-height: px2rem(230px);
    font-size: px2rem(140.625px);
    color: #02c9fa;
  }
}
.center {
  width: px2rem(750px);
  background-color: white;
  li {
    width: px2rem(693.75px);
    height: px2rem(84.375px);
    line-height: px2rem(84.375px);
    border-bottom: px2rem(2.34375px) solid #ebebeb;
    margin: 0 auto;
    position: relative;
    font-size: px2rem(28.125px);
    .item-val {
      position: absolute;
      right: 0;
      top: 0;
      color: #666666;
    }
    .bind {
      color: #00a6ec;
    }
    .change-company {
      background: url("../../assets/svg/table-row-arrow.svg") right center
        no-repeat;
      padding-right: px2rem(23.4375px);
      background-size: px2rem(28.125px) px2rem(39.84375px);
      text-align: right;
      span {
        display: block;
        float: right;
      }
      span.companyName {
        // display: inline-block;
        width: px2rem(328.125px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
.logout {
  display: block;
  width: px2rem(750px);
  height: px2rem(126.5625px);
  line-height: px2rem(126.5625px);
  font-size: px2rem(32.8125px);
  text-align: center;
  color: black;
  background-color: white;
  margin-top: px2rem(187.5px);
}
</style>

